import LocalStorage from "./LocalStorage"
import {Howl, Howler} from 'howler';
import YoutubeApi from "./YoutubeApi"

export default class AudioAPI {
}

let timer;

AudioAPI.player = null;
AudioAPI.src = null;
AudioAPI.stepId = null;


AudioAPI.setSrc = function (fileUrl) {
    this.src = fileUrl

}

AudioAPI.setStepId = function (stepId) {
    this.stepId = stepId
}

AudioAPI.init = function () {
    if (this.player) {
        this.player.stop()
    }

    this.player = new Howl({
        preload: true,
        src: [this.src],
        onend: () => {
            clearInterval(timer)
            LocalStorage.setMediaOffset(this.stepId, 0);
        }
    });

    const offset = LocalStorage.getMediaOffset(this.stepId)
    if (offset > 0) {
        this.player.seek(offset)
    }
}

AudioAPI.saveStartTimeOffset = function () {
    let offset = AudioAPI.player.seek();
    if (offset < 0) {
        offset = 0
    }

    offset = Math.floor(offset)
    LocalStorage.setMediaOffset(AudioAPI.stepId, offset);
    let newEvent = new CustomEvent("audio-playing", {detail: offset});
    document.dispatchEvent(newEvent);
}

AudioAPI.play = function () {
    this.player.play()
    timer = setInterval(this.saveStartTimeOffset, 1000)
}

AudioAPI.stop = function () {
    if (this.player) {
        clearInterval(timer)
        LocalStorage.setMediaOffset(this.stepId, 0);
        this.player.stop()
    }
}

AudioAPI.pause = function () {
    if (this.player) {
        clearInterval(timer)
        this.player.pause()
    }
}
